import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingBag } from "lucide-react";

const ALLOWED = new Set(["/", "/book", "/shop"]);

export function FloatingBuyButton() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!ALLOWED.has(pathname)) {
      setVisible(false);
      return;
    }
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [pathname]);

  if (!ALLOWED.has(pathname)) return null;

  return (
    <Link
      to="/shop"
      aria-label="Get the book — go to shop"
      className={`fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-primary px-5 py-3 font-display text-sm font-bold text-primary-foreground shadow-bold ring-2 ring-secondary/20 transition-all duration-300 hover:scale-105 hover:shadow-xl md:bottom-8 md:right-8 md:px-6 md:py-3.5 md:text-base ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-6 opacity-0"
      }`}
    >
      <ShoppingBag className="h-4 w-4 md:h-5 md:w-5" aria-hidden="true" />
      Get the Book
    </Link>
  );
}
